<div class="dropstart">
  <button
    class="btn"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <div class="profile-icon">
      <p>{{ initials }}</p>
    </div>
  </button>
  <ul class="dropdown-menu">
    <li>
      <button class="dropdown-item" (click)="navigateToAddressChangeRequest()">
        {{ requestAddressChangeItem.name | msg | async }}
      </button>
    </li>
    <li>
      <button class="dropdown-item" (click)="navigateToPasswordChange()">
        {{ changePasswordItem.name | msg | async }}
      </button>
    </li>
    <li>
      <button class="dropdown-item" (click)="signOut()">
        {{ signOutItem.name | msg | async }}
      </button>
    </li>
  </ul>
</div>
